import { render, staticRenderFns } from "./SecondBlockRule.vue?vue&type=template&id=5c90fe29&scoped=true"
import script from "./SecondBlockRule.vue?vue&type=script&lang=js"
export * from "./SecondBlockRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c90fe29",
  null
  
)

export default component.exports